export const RECEIVE_PROMOTIONS = 'RECEIVE_PROMOTIONS';
export const RECEIVE_CURRENT_STORE = 'RECEIVE_CURRENT_STORE';
